import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Card, Form, Input, Space, Switch } from "antd";
import HelpLabel from "../../../../components/HelpLabel";
import { validateEmailCsv } from "../../../../../../swzutils/ValidationUtil";
const IcsSettings = ({ form, settings }) => {
    const [integrationActive, setIntegrationActive] = useState(false);
    const [editApiKeyActive, setEditApiKeyActive] = useState(true);
    const onActiveChanged = (active) => {
        setIntegrationActive(active);
    };
    const toggleEditApiKey = () => {
        if (!integrationActive) {
            return;
        }
        setEditApiKeyActive(!editApiKeyActive);
    };
    useEffect(() => {
        if (settings) {
            form.setFieldsValue({
                "icsApiKey": editApiKeyActive ? "" : settings.maskedApiKey
            });
        }
    }, [editApiKeyActive]);
    useEffect(() => {
        if (settings?.active) {
            form.setFieldsValue({
                icsActive: true,
                icsBaseUrl: settings.baseUrl,
                icsApiKey: settings.maskedApiKey,
                icsErrorEmailCsv: settings.errorEmailAddressCsv,
            });
            setIntegrationActive(true);
            setEditApiKeyActive(false);
        }
    }, [settings]);
    return (_jsxs(Card, { title: "ICS", type: "inner", variant: "outlined", children: [_jsx(Form.Item, { name: "icsActive", initialValue: false, valuePropName: "checked", children: _jsx(Switch, { checkedChildren: "Active", unCheckedChildren: "Not Used", onChange: onActiveChanged }) }), _jsx(Form.Item, { label: _jsx(HelpLabel, { title: "Api Key", helpText: "This value is obtained from ICS." }), children: _jsxs(Space.Compact, { block: true, children: [_jsx(Form.Item, { name: "icsApiKey", noStyle: true, rules: [
                                { required: integrationActive, message: 'When the ICS integration is active an API key is required.' }
                            ], children: _jsx(Input, { type: "text", disabled: !integrationActive || !editApiKeyActive }) }), settings && settings.active &&
                            _jsx(Space.Addon, { children: _jsx("a", { onClick: toggleEditApiKey, children: editApiKeyActive ? "Cancel" : "Edit" }) })] }) }), _jsx(Form.Item, { name: "icsBaseUrl", label: "Base URL", rules: [
                    { required: integrationActive, message: 'When the ICS integration is active a Base URL is required.' }
                ], children: _jsx(Input, { type: "text", disabled: !integrationActive }) }), _jsx(Form.Item, { name: "icsErrorEmailCsv", label: "Error Email Address(s)", rules: [
                    { required: integrationActive, message: 'When the ICS integration is active an error email address is required.' },
                    { validator: validateEmailCsv }
                ], children: _jsx(Input, { type: "text", disabled: !integrationActive }) })] }));
};
export default IcsSettings;
